import { Injectable, TemplateRef } from '@angular/core';
import {  NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import {OpcaoConfirmacao} from './opcao-confirmacao-model'

/**
 * Serviço interno que permite acessar as opções a partir do modal de confirmação e também registra
 * a referência para o template
 *
 * Precisa ser declarado como providers do NgModule,mas não deve ser usado pelo código da aplicação
 */
@Injectable()
export class SituacaoConfirmacaoService 
{
  /**
   * Ultima opção retornada pelo método ConfirmacaoModalService.confirmar()
   */
  opcoes: OpcaoConfirmacao;

  /**
   * Último modal aberto
   */
  modal: NgbModalRef;

  /**
   * Template que contém o modal de confirmação
   */
  template: TemplateRef<any>;
}
